exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.btn.text-left.btn-light.btn-block.collapsed{background:#efefef;color:#818181;font-weight:700}", ""]);

// exports
